import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { IUserGroups } from '../add-user/add-user-management.interface';
import { Utility } from 'src/app/shared/utils/utility.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'src/app/shared-layout/Components/confirm-dialog/confirm-dialog.component';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { IUser } from '../user-management-interfaces';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { UserTypeRequest } from 'src/app/shared/constants/request-mapping';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-filter-users',
  templateUrl: './filter-users.component.html',
  styleUrls: ['./filter-users.component.scss'],
})
export class FilterUsersComponent implements OnInit {
  stepper: number = 1;
  CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  filter!: (string | undefined)[];
  selectedRoles: string[] | undefined = [];
  updateSelectedRoles: string[] | undefined = [];
  userRoles: IUserGroups = Utility.getUserRoles(this.translate);
  user: IUser | undefined;
  excludePMAAndPMU = ['dashboard/users', 'dashboard'];

  constructor(
    public dialogRef: MatDialogRef<FilterUsersComponent>,
    @Inject(MAT_DIALOG_DATA) objectRoles: string[],
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    private router: Router,
    private helperService: HelperService,
    public stateManagementService: StateManagementService,
    private translate: TranslateService
  ) {
    // Access the current route URL
    this.selectedRoles! = objectRoles;
  }

  ngOnInit(): void {
    const currentRoute = this.router.url;
    this.user = this.stateManagementService.getUser();

    const index = this.userRoles?.findIndex((userRole) => {
      let userType = this.user?.userType;
      return userRole?.value === UserTypeRequest[userType!];
    });
    this.userRoles = this.userRoles?.slice(index);
    if (
      this.excludePMAAndPMU.some((route) => currentRoute?.includes(route)) &&
      this.user?.userType === CONSTANTS.PROPERTY_MANAGER_ADMIN
    ) {
      this.userRoles = this.userRoles?.slice(2);
    } else if (
      this.excludePMAAndPMU.some((route) => currentRoute?.includes(route)) &&
      this.user?.userType === CONSTANTS.PROPERTY_MANAGER_USER
    ) {
      this.userRoles = this.userRoles?.slice(1);
    }

    if (this.selectedRoles) {
      this.userRoles = this.userRoles?.map((userRole: any) => {
        if (this.selectedRoles?.includes(userRole.value)) {
          return { ...userRole, active: true };
        } else {
          return { ...userRole };
        }
      });
    }
  }

  /**
   * @description: closeDialog function close the dialogRef.
   * @input none
   * @output { void }
   */

  closeDialog() {
    if (this.selectedRoles?.length === 0) {
      this.dialogRef?.close();
      return;
    }
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmDialogComponent,
      {
        title: this.translate.instant('TITLE'),
        headingText: this.translate.instant('HEADING_TEXT'),
        bodyText: this.translate.instant('BODY_TEXT'),
        footerText: this.translate.instant('FOOTER_TEXT'),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef?.close();
      }
    });
  }

  /**
   * @description: navigateBack function set the step to 1.
   * @input none
   * @output { void }
   */
  navigateBack() {
    this.stepper = 1;
  }

  /**
   * @description: #changeStep function set the step to 2 for User Roles
   *               and 3 for Users.
   * @param { string } step
   * @output { void }
   */
  changeStep(step: string) {
    if (step === CONSTANTS.USER_TYPE) this.stepper = 2;
  }

  /**
   * @description: #selectUserType function accepts selected userType from the list
   * @input { string }
   * @param { userType }
   * @output { void }
   */

  selectUserType(userType: number) {
    let updatedUserRoles = this.userRoles
      ?.filter((userRole: any) => {
        return userRole.value === userType;
      })
      .map((userRole: any) => {
        return (userRole.active = !userRole.active);
      });

    this.selectedRoles = this.userRoles
      ?.filter((userRole: any) => {
        return userRole?.active;
      })
      .map((userRole: any) => {
        return userRole?.value;
      });
  }

  /**
   * @description: #resetFilter function resets all selected user roles
   * @output { void }
   */

  resetFilter(): void {
    this.selectedRoles = [];
    this.userRoles = this.userRoles?.map((userRole: any) => {
      return { ...userRole, active: false };
    });
  }

  /**
   * @description: #applyFilter function will apply the final changes
   *                to the filterUser aftreClosed subscriber.
   * @output { void }
   */
  applyFilter(): void {
    this.dialogRef?.close(this.selectedRoles);
  }
}
